// Fila de tickets (/v3/crm/tickets/new-tickets): abas-filtro com contagem e tempo real (Demanda 04).
// Spec docs/ticket-detail-2027/02-design/d04-v01.md; contrato 04-php/contrato-d04.md (E-ABA, E3, E-SYNC).
//
// - Fora do .bt-ajax/switchReturns (risco R1): fetch próprio, rotas sempre HTTP 200; erro = a tela fica como estava.
// - Troca de aba: vale o último clique (resposta velha descartada por número de sequência); esqueleto só após 200 ms.
// - Tempo real SÓ por Pusher (D04-4): LiaTicketEvent (ticket_id) e LiaMessageEvent (e.chatMessage.chat.ticket_id;
//   ignora action 'update-event'). Eventos agrupados em lote de 1,5 s: 1 contagem + 1 sincronização por lote.
// - Canal lia.{CLIENT_NAME} é do Lia.js também (LICOES 17 / FE-1): nunca Echo.leave, nunca stopListening sem o
//   próprio handler; registra DEPOIS do Lia.init(); re-assina no pageshow restaurado do bfcache.
// - "Carregar mais" continua .bt-ajax com a proximaUrl do servidor (cursor); nada de página calculada aqui.
// - Gancho de teste sempre exposto: window.tkFila.receberEvento(nome, payload) → Promise; window.tkFila.estado().
// - D13-9 (a): os 9 chips moram no .tk-filtros; o escopo .tk-fila-head foi mantido (d13-9-v02 §3).
// - D14: aba "Esperando" é a única CRESCENTE (id ASC no empate); ponto do chip por data-espera; região viva
//   quando a contagem de Esperando sobe; tique LOCAL de 60 s que só reescreve o texto dos selos de espera (sem requisição).
//   D29 (04-php/d29.md F1): a chave dela (data-desde = ordem.created do E-SYNC = antes_de) é a string "<grupo>|<K>", grupo 0 =
//   transbordo da LIA, 1 = o resto; K = COALESCE(lia_handoff_at, date_client_last_comment). Comparada como string opaca.
// - D29 F2 v03 (04-php/d29.md §v03-2 + parecer-d29-php-v03 R-A/R-C): na Aguardando a chave é MUTÁVEL e ASC, então um item já
//   listado cuja chave subiu pode não ter alvo na janela. Com "Carregar mais", compara com o cursor do botão (antes_de/antes_id do
//   data-ajax, pelo mesmo antesDe): depois do cursor = sai (o cursor o traz); senão, fim do DOM; cursor ilegível ou botão disabled
//   (página em voo) = fim do DOM. Item aberto / "Atender o próximo" em curso fica no lugar com a chave ANTIGA.
// - R2 do parecer-d14-php: aba da URL que falhou na carga (#tk-fila-aviso[data-falhou-na-carga]) → tira o `aba` da URL.
// - D17b: a guarda de saída mora no componente SaidaDetalhe (sair/motivoTrabalho/clicarLiberado); aqui só as chamadas.
// - D17 (d17-v01 + d17-v02): trocar de filtro esvazia o detalhe. A regra mora em SaidaDetalhe.sair(origem) → Promise<boolean>,
//   chamada ANTES de qualquer mutação pelo chip ≠ ativo ('chip'), pelo "Tentar de novo" ('tentar') e pelo "×"/Esc da busca
//   com busca aplicada ('limpar'). Guarda G1–G5 (gravação em curso BLOQUEIA, LICOES 41). Nunca rejeita; flag `saindo`
//   zerada em qualquer desfecho (R1 do parecer-d17-design-v02); sem Swal, a guarda resolve false (R2).
// - D18 (d18-v01 §4 + d18-v02 §2): chip ativo sempre inteiro na faixa de uma linha (mostrarChip, só scrollLeft). O focusin só
//   rola com :focus-visible (foco de mouse rolaria entre mousedown e mouseup e o clique se perderia, LICOES 43).
// - D21 (d21-v01 §4/§6 + v02 §3 + v03 §4): ordem pelo contato mais recente (data-contato; Esperando continua data-desde ASC);
//   item já na lista cuja chave mudou SOBE (mesmo nó), adiado sob hover/foco/Assumir/abertura; âncora do LOTE inteiro com referência
//   FORA do lote; ponto/descrição do chip Comigo pela contagem `comigo-novos` e região viva só na subida.
// - D20 (d18-v01 §8 + d18-v02 §3/§4): "×" da busca (visível com texto OU com `search` na URL); limpa só a busca.
// - D19 (d19-v01 §5.2/§5.3 + v02 §3/§5 + v03 §2): camada "Assumir" do detalhe. Checagem do Pusher com query EXATAMENTE {aba, ids}
//   (sem o query() da página); armar/desarmar o Assumir da camada; selo de espera da camada no tique; Assumir da fila sobre o
//   ticket aberto clica o "Abrir de novo" da camada.

// - D24 (d24-v01 §3.A1/A3 + d24-v02 §2/§3 + d24-v03): A1 pulso do chip Esperando ("Aguardando") = data-pulso por 4,8 s na SUBIDA da
//   contagem (ou na 1ª contagem com > 0), nunca no chip ativo, nem com pulso em curso, nem a menos de 30 s do último; aba do navegador
//   escondida → 1 gatilho pendente avaliado no visibilitychange. O fundo âmbar fixo e o do item em espera (A2) são só CSS.
//   A3 som + toast: LiaTicketEvent action 'lia-handoff' com #tk-fila[data-aviso-transbordo="1"] → AvisoTransbordo.avisar(id).
// - D27 (d27-v01 §1.4/§3 + d27-v02 §3): pílula com a quantidade disponível no "Atender o próximo" = contagem `sem-dono`, só com a
//   contagem comparável (comparavel(): sem filtro legado na URL, mesma regra do blade). Falha mantém o número anterior, como o chip.
//   Depois do POST do botão (sucesso ou erro), 1 recontagem no lote (sem Pusher nada recontaria). d27-v03 §1.2: o gancho é um
//   jqXHR.always registrado no ajaxPrefilter (roda ANTES do s.success do confirmFunction, que lança no switchReturns); o
//   ajaxComplete nunca chegava no sucesso.
// - D35 v17 §4/§5 (DF-1 a + grupos; contrato 04-php/d35-g.md): DOIS filtros (atendente × situação, uma fileira cada, um chip ligado em
//   cada; chip ligado ≠ Todos/Abertos desliga, lab talk.js:2463-2495). A vista é o par "<atendente>:<situacao>" (= r.aba do servidor).
//   `modo` (grupos/aguardando/corrida) escolhe o comparador; no modo grupos a ordem é donos.indexOf(dono) e, no empate, a D21. Os títulos
//   de grupo são SÓ deste arquivo (regrupar(), idempotente), clonados do <template id="tk-grupo-modelos"> do blade.
// - D30 (04-php/d30-v02.md §6 + rev-d30 §5): o Assumir da fila (bt-confirm do miolo ou o temporário do SaidaDetalhe) com
//   error:false, method replace-multi-elements e result.chat 'falha' = ticket assumido, conversa do WhatsApp não passou. Mesmo gancho
//   da D27 (ajaxPrefilter + jqXHR.done, antes do s.success). O aviso fica PENDENTE por id e só sai depois do conferirAssumidos
//   (abrirAssumido já disparado), num Swal `text:` (texto fixo da chave, nunca o message do servidor), quando não houver Swal nem
//   Loader na tela (a abertura do detalhe terminou). Um aviso por vez. O ramo `reload` não avisa (contrato B-C).

const SaidaDetalhe = require('./SaidaDetalhe');   // D17b: guarda de saída do detalhe (antes era local deste arquivo)
const AvisoTransbordo = require('./AvisoTransbordo');   // D24 A3

const LOTE_MS = 1500;
const CONTAGEM_MIN_MS = 10000;   // evento de OUTRO atendente: no máximo 1 recontagem a cada 10 s (cada uma = ~11 chamadas no servidor)
const ESQ_MS = 200;
const SYNC_MAX = 15;   // contrato E-SYNC: no máximo 15 ids por chamada
const TXT_CONTAGEM_ERRO = 'Contagem indisponível agora.';
const TIQUE_MS = 60000;   // D14-5: o relógio do selo de espera (só formatação, nunca recontagem: D04-4)
const SELOS_ESPERA = '#tk-fila-itens .tk-tag[data-tom="espera"], .tk-camada .tk-tag[data-tom="espera"]';   // D19 (d19-v02 §5)
const CAMADA_TETO_MS = 60000;   // D19 (d19-v02 §3.3 c)
const FOLGA_ESQ = 4;      // D18: anel externo (outline 2 + offset 2)
const FOLGA_DIR = 36;     // D18: esmaecido 32 + anel 4
const PULSO_MS = 4800;          // D24-2 (c'): 2 ciclos de 2400 ms (o relógio é o dono do fim, sem animationend)
const PULSO_INTERVALO_MS = 30000;   // no máximo 1 pulso a cada 30 s (contado do INÍCIO do último)
const AVISO_CHAT_PASSO_MS = 150;     // D30: intervalo da espera por "sem Swal e sem Loader"
const AVISO_CHAT_TETO_MS = 60000;    // D30: depois disso o aviso sai mesmo com o Loader (com Swal alheio, só a região viva)
const AVISO_CHAT_REEXIBIR_MAX = 3;   // D30 v02 (FAIL-01): no máximo 3 reexibições depois de o Swal do aviso ser trocado por outro
// D30: o Assumir da fila (fila-item-miolo: crm.ticketsSetResponsible com from=tickets); grupo 1 = ticket_id = #opportunity_{id}.
const URL_ASSUMIR = /\/tickets\/set-responsible\/\d+\/(\d+)\/\d+\/?$/;
// D27 (d27-v02 §3.3): chaves que mudam a filaBase e que o atenderProximo ignora.
const CHAVES_LEGADAS = ['status_id', 'channel', 'type', 'dtInitial', 'dtEnd', 'period'];
// Mesmo conjunto do TrimStrings do Laravel (PCRE `\s` com /u + FEFF + 200B): o `\s` do JS não tem U+0085 nem U+180E (LICOES 33).
const APARAR = /^[\s\u0085\u180E\u200B\uFEFF]+|[\s\u0085\u180E\u200B\uFEFF]+$/g;

const FilaAbas = function () {

    let fila, cabeca, lista, itens, rodape, bloco, aviso, status, novosBtn, campo, limpar, modelos;
    let T = {};                  // textos do data-textos do #tk-fila (D14 / aviso), lidos com __() no blade
    let esperaConhecida = null;  // última contagem de Esperando (região viva só na subida)
    let pulsoDaPagina = true;    // D24/J-11: só a 1ª contagem DA PÁGINA pulsa com > 0 (a 1ª de uma vista nova não)
    let novosConhecidos = null;  // D21: última contagem de comigo-novos (região viva só na subida)
    let proximo = null, proximoDesc = null;   // D27: o .tk-proximo original (nunca o tk-saida-tmp) e o #tk-proximo-desc
    const esperaT0 = new WeakMap();   // selo de espera → performance.now() de quando entrou na tela
    let urls = {};
    // D35 v17 J-1: o par (atendente, situacao) e o modo da vista; `carregada` = o par que está NA TELA. grupos: null = vista sem grupos.
    const est = { atendente: 'todos', situacao: 'abertos', modo: 'grupos', donos: ['comigo', 'lia', 'sem-dono', 'equipe'], grupos: {},
                  vazioMotivo: null, carregada: null, total: null, carregandoAba: false, sincronizando: false, novos: 0 };
    let esperaFixa = false;   // J-11 (R-1 do servidor): a contagem do pulso veio da chave fixa `aguardando-total` (independe da vista)
    const vista = () => est.atendente + ':' + est.situacao;
    let seqAba = 0;          // última troca de aba pedida
    let versaoLista = 0;     // muda a cada troca de aba concluída: sync de lista antiga é descartada
    let lote = new Set();    // ticket_ids do lote atual
    let loteTimer = null;
    let loteEspera = [];     // {resolve, reject} das chamadas do lote atual
    let loteAnunciado = false;
    let canal = null;
    let jaConectou = false;

    // ---------- utilidades ----------
    const fmt = (n) => Number(n).toLocaleString('pt-BR');
    // D13-9 (a): os chips moram nos .tk-filtros; o escopo .tk-fila-head foi mantido (d13-9-v02 §3). D35 v17 J-2: duas fileiras
    // ([data-eixo] atendente / situacao); os valores de data-aba não se repetem entre elas, então chipDa continua único.
    const chips = () => Array.from(cabeca.querySelectorAll('.tk-chip[data-aba]'));
    const chipDa = (aba) => cabeca.querySelector('.tk-chip[data-aba="' + aba + '"]');
    const fileiras = () => Array.from(cabeca.querySelectorAll('.tk-filtros[data-eixo]'));
    const eixoDe = (c) => { const f = c ? c.closest('.tk-filtros') : null; return f ? f.dataset.eixo : null; };
    const t = (k, p) => String(T[k] || k).replace(/:([a-z]+)/g, (m, c) => (p && c in p ? String(p[c]) : m));
    const nomeDa = (aba) => { const c = chipDa(aba); return c ? c.querySelector('.tk-chip-nome').textContent.trim() : aba; };
    // J-12: o nome da vista ("Comigo · Atrasados"), no #tk-bloco, no anúncio e no aviso de falha.
    const nomeDaVista = (par) => nomeDa((par || est).atendente) + ' · ' + nomeDa((par || est).situacao);
    const busca = () => new URL(location.href).searchParams.get('search') || '';
    const anunciar = (t) => { if (status) { status.textContent = ''; status.textContent = t; } };
    const reduzMovimento = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---------- D18: chip ativo inteiro na faixa ----------
    // Rola SÓ a faixa (scrollLeft), nunca scrollIntoView (rolaria a página/coluna). Menor deslocamento, sem animação.
    // D35 v17 J-3: a fileira é a do próprio chip (cada uma rola sozinha; a de cima não anda quando a situação muda).
    const inteiro = (c) => {
        const f = c.closest('.tk-filtros');
        const b = f.getBoundingClientRect(), r = c.getBoundingClientRect();
        return r.left >= b.left + FOLGA_ESQ - 0.5 && r.right <= b.right - FOLGA_DIR + 0.5;
    };
    const mostrarChip = (c) => {
        const f = c ? c.closest('.tk-filtros') : null;
        if (!f || f.hasAttribute('data-arrastando')) return;   // D22: não briga com o arrasto do ChipsRolagem
        const b = f.getBoundingClientRect(), r = c.getBoundingClientRect();
        if (r.left < b.left + FOLGA_ESQ) f.scrollLeft -= (b.left + FOLGA_ESQ) - r.left;
        else if (r.right > b.right - FOLGA_DIR) f.scrollLeft += r.right - (b.right - FOLGA_DIR);
    };
    const mostrarAtivos = () => { mostrarChip(chipDa(est.atendente)); mostrarChip(chipDa(est.situacao)); };

    // Ticket aberto: a faixa do detalhe (B1) ou, sem ela, o item marcado.
    const aberto = () => {
        const f = document.querySelector('.tk-faixa[data-ticket]');
        if (f) return parseInt(f.dataset.ticket, 10) || null;
        const a = document.querySelector('#tk-fila-itens .tk-item[aria-current="true"]');
        return a ? parseInt(a.id.replace('opportunity_', ''), 10) || null : null;
    };

    // D08 R-2: item com abertura em andamento (marcado pelo FilaSelecao). Para a sync conta como "aberto".
    const abrindo = () => {
        const a = document.querySelector('#tk-fila-itens .tk-item[data-abrindo]');
        return a ? parseInt(a.id.replace('opportunity_', ''), 10) || null : null;
    };

    // Query da página (busca + filtros legados), com a aba informada. Nunca leva cursor/página.
    const query = (extra) => {
        const p = new URLSearchParams(location.search);
        ['page', 'pag', 'return', 'antes_de', 'antes_id', 'antes_dono', 'aba', 'lated'].forEach(k => p.delete(k));   // D35 G: aba/lated = legado
        Object.keys(extra || {}).forEach(k => {
            if (extra[k] === null || extra[k] === undefined || extra[k] === '') p.delete(k); else p.set(k, extra[k]);
        });
        return p.toString();
    };

    const getJSON = (base, qs, signal) => fetch(base + (qs ? '?' + qs : ''), {
        method: 'GET', credentials: 'same-origin', signal: signal,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    }).then(r => {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
    }).then(d => {
        if (!d || d.error) throw new Error('erro');
        return d.result;
    });

    const fragmento = (html) => { const t = document.createElement('template'); t.innerHTML = html || ''; return t.content; };

    // ---------- cabeçalho: X / total ----------
    const contarX = () => itens.querySelectorAll('.tk-item:not([data-fora])').length;

    const pintarBloco = (mostrarNumeros) => {
        bloco.querySelector('.tk-grupo-tit').textContent = nomeDaVista();   // J-12 (o #tk-bloco é sr-only: G-P10)
        const small = bloco.querySelector('small');
        const ok = mostrarNumeros && est.total !== null;
        small.hidden = !ok;
        if (ok) {
            small.querySelector('[data-tk-x]').textContent = fmt(contarX());
            small.querySelector('[data-tk-total]').textContent = fmt(est.total);
        }
    };

    // FE-3: rede de segurança contra #opportunity_{id} duplicado (fica o primeiro) + recálculo do X.
    // R-2: o Assumir (.bt-confirm → replace-multi-elements) troca o miolo sem passar por aqui e perderia o selo
    // "fora deste filtro". Guarda o ticket do Assumir clicado; quando o miolo DELE muda, agenda a sincronização
    // desse id no lote de 1,5 s. As trocas feitas pela própria sincronização não estão nesta lista (sem laço).
    const assumidos = new Map();   // id -> timer de expiração (60 s: confirmação cancelada não fica para sempre)
    const marcarAssumir = (e) => {
        const btn = e.target instanceof Element ? e.target.closest('.tk-assumir') : null;
        const art = btn ? btn.closest('.tk-item') : null;
        if (!art || !itens.contains(art)) return;
        const id = parseInt(art.id.replace('opportunity_', ''), 10);
        if (!id) return;
        clearTimeout(assumidos.get(id));
        assumidos.set(id, setTimeout(() => {
            assumidos.delete(id);
            // D08 R-1: se a sync adiou a saída deste item, o Assumir não deu certo (ou foi cancelado): devolve o id
            // ao lote UMA vez e a próxima sync o tira da lista. Sem polling enquanto o registro está vivo.
            if (adiados.delete(id)) devolverAoLote([id]);
        }, 60000));
    };
    // D08 R-1: ids que a sync deixou de remover porque o Assumir deles estava em andamento.
    const adiados = new Set();
    // <article>s cujo miolo a PRÓPRIA sincronização trocou (borda b do parecer-d04-front-v011): essas mutações não
    // consomem a entrada do Assumir nem abrem o ticket. Limpo ao fim de cada entrega do observer (a escrita da sync e a
    // resposta do P3 chegam em tarefas diferentes, logo em entregas diferentes).
    const escritosPelaSync = new Set();

    // D08: Assumir deu certo (o P3 trocou o miolo) → abre o ticket assumido pelo MESMO caminho do clique no item
    // (.tk-item-abrir: bt-ajax → openOppByUser?ticket_id; o FilaSelecao marca o aria-current quando o detalhe chega).
    // Não reabre se ele já é o aberto; respeita a trava do FilaSelecao (botão disabled = outra abertura pendente).
    // Erro do Assumir (alerta, reload ou sem troca do miolo) não chega aqui: nada abre.
    // D17b (d17b-v02 §3): com trabalho REAL no detalhe (motivoTrabalho, nunca o "ocupado"), não abre e avisa; um descarte já confirmado
    // no Assumir combinado (consumirAceito) abre sem 2ª pergunta. Todo .click() sintético via SaidaDetalhe.clicarLiberado (finally).
    const abrirAssumido = (art, id) => {
        if (!art.isConnected) return;
        if (id === aberto()) {
            // D19 (d19-v01 §5.3): o Assumir da fila sobre o ticket aberto com camada → "Abrir de novo" redesenha sem a camada.
            const re = document.querySelector('.tk-camada[data-ticket="' + id + '"] .tk-camada-reabrir');
            if (re && !re.disabled) SaidaDetalhe.clicarLiberado(re);
            return;
        }
        const btn = art.querySelector('.tk-item-abrir');
        if (!btn || btn.disabled) return;
        const aceito = SaidaDetalhe.consumirAceito(id);
        if (aceito || SaidaDetalhe.motivoTrabalho() === null) SaidaDetalhe.clicarLiberado(btn);
        else anunciar(t('assumido_sem_abrir', { id: id }));
    };

    // D30: aviso de "ticket assumido, conversa do WhatsApp não passou". pendentes = resposta com chat 'falha' cujo miolo ainda
    // não trocou; fila = prontos para exibir, um Swal por vez, só sem Swal e sem Loader na tela (motivoClique 'ocupado' = G1/G2).
    const avisoChatPendente = new Set();
    // D30 v02 (FAIL-01 do 06-qa/d30-ciclo01): os execute-ajax-on-load do detalhe rodam SEM Loader, e o showAlert de erro deles troca o
    // Swal do aviso (o Swal é um só). (1) O texto vai SEMPRE para a região viva na 1ª exibição. (2) Swal do aviso trocado por outro
    // (Swal 11.10.5: a promessa do anterior resolve {isDismissed:true} SEM `dismiss`; o mesmo vale para Swal.close() de código) → volta
    // para a frente da fila com o MESMO t0 (mesmo teto) e reaparece quando a tela ficar livre, até AVISO_CHAT_REEXIBIR_MAX vezes.
    // Fechado pelo usuário (Ok, Esc, fundo, ×: `dismiss` preenchido ou isConfirmed) = visto, não volta. Reload da página perde o aviso.
    const avisoChatFila = [];   // { id, t0, vezes, anunciado }
    let avisoChatTimer = null;
    const exibirAvisoChat = () => {
        avisoChatTimer = null;
        const a = avisoChatFila[0];
        if (!a) return;
        const S = window.Swal && typeof window.Swal.fire === 'function' ? window.Swal : null;
        const estourou = performance.now() - a.t0 >= AVISO_CHAT_TETO_MS;
        if (!estourou && SaidaDetalhe.motivoClique() === 'ocupado') { agendarAvisoChat(); return; }
        avisoChatFila.shift();
        const txt = t('assumir_chat_falha', { id: a.id });
        if (!a.anunciado) { a.anunciado = true; anunciar(txt); }   // região viva sempre, uma vez por aviso
        if (S && !S.isVisible()) {
            a.vezes = (a.vezes || 0) + 1;
            const p = S.fire({ icon: 'warning', text: txt, confirmButtonText: t('ok') });   // text: (LICOES 31); padrão do FaixaFinalizar
            if (p && typeof p.then === 'function') {
                p.then((r) => {
                    const trocado = !!r && r.isDismissed === true && !r.dismiss;
                    if (!trocado || a.vezes > AVISO_CHAT_REEXIBIR_MAX) return;
                    avisoChatFila.unshift(a);   // mesmo t0: o teto conta da 1ª soltura
                    agendarAvisoChat();
                }, () => {});
            }
        }
        // sem Swal no bundle, ou Swal alheio aberto há mais que o teto: não o substitui (o texto já foi para a região viva)
        if (avisoChatFila.length && avisoChatFila[0] !== a) { avisoChatFila[0].t0 = performance.now(); agendarAvisoChat(); }
    };
    const agendarAvisoChat = () => {
        if (avisoChatTimer === null) avisoChatTimer = setTimeout(exibirAvisoChat, AVISO_CHAT_PASSO_MS);
    };
    const soltarAvisoChat = (id) => {
        if (!avisoChatPendente.delete(id)) return;
        avisoChatFila.push({ id: id, t0: performance.now() });
        agendarAvisoChat();
    };

    const conferirAssumidos = (registros) => {
        const vistos = new Set();
        registros.forEach(m => {
            if (m.type !== 'childList') return;   // só troca de miolo; atributos (data-abrindo) são do R-3
            const art = m.target instanceof Element && m.target.classList.contains('tk-item') ? m.target : null;
            if (!art || vistos.has(art) || escritosPelaSync.has(art)) return;
            vistos.add(art);
            const id = parseInt(art.id.replace('opportunity_', ''), 10);
            if (!assumidos.has(id)) { soltarAvisoChat(id); return; }   // D30: sem o registro do clique, o aviso sai igual
            clearTimeout(assumidos.get(id));
            assumidos.delete(id);
            adiados.delete(id);
            devolverAoLote([id]);        // R-2 / D08 R-1: a sync seguinte marca "fora deste filtro" (agora é o aberto)
            abrirAssumido(art, id);      // D08
            soltarAvisoChat(id);         // D30: depois do abrirAssumido; a espera por Loader/Swal cobre a abertura do detalhe
        });
        escritosPelaSync.clear();
    };

    // D08 R-3: data-abrindo saiu sem a abertura dar certo (sem aria-current) e a sync tinha posto data-fora:
    // devolve o id ao lote para a próxima sync remover o item ou restaurá-lo conforme a aba.
    const conferirAbrindo = (registros) => {
        registros.forEach(m => {
            if (m.type !== 'attributes' || m.attributeName !== 'data-abrindo') return;
            const art = m.target;
            if (art.dataset.abrindo || !art.dataset.fora || art.getAttribute('aria-current') === 'true') return;
            const id = parseInt(art.id.replace('opportunity_', ''), 10);
            if (id) devolverAoLote([id]);
        });
    };

    // D09 F-2: com o "Atender o próximo" em andamento, a sync da aba "Sem dono" não remove itens (o assumido sairia
    // antes de o detalhe chegar e nunca ganharia o "fora deste filtro"). Solta quando o detalhe chega ou em 60 s,
    // devolvendo os adiados ao lote uma vez.
    let atendendo = false;
    let atendendoTeto = null;
    const adiadosProximo = new Set();
    const soltarAtendendo = () => {
        if (!atendendo) return;
        atendendo = false;
        clearTimeout(atendendoTeto);
        atendendoTeto = null;
        const ids = Array.from(adiadosProximo);
        adiadosProximo.clear();
        if (ids.length) devolverAoLote(ids);
    };
    const armarAtendendo = (e) => {
        const prox = e.target instanceof Element ? e.target.closest('.tk-proximo') : null;
        if (!prox || (prox.disabled && !prox.classList.contains('tk-saida-tmp'))) return;   // D17b F1: o temporário já vem desabilitado pelo .bt-ajax
        atendendo = true;
        clearTimeout(atendendoTeto);
        atendendoTeto = setTimeout(soltarAtendendo, 60000);
    };

    const aoMudarLista = (registros) => {
        if (registros) { conferirAssumidos(registros); conferirAbrindo(registros); }
        // FE-3: #opportunity_{id} duplicado → fica UM. Com o mesmo dono, o primeiro (D29: a cópia que a sync já pôs no lugar). F-1 do
        // parecer-d35-bloco-g: com donos diferentes, a cópia velha é a que a exceção do aberto deixou no grupo antigo, e a do "Carregar mais" está
        // no grupo certo (fila_dono do servidor) → fica a ÚLTIMA, e ela herda a marca de aberto. Nunca apaga a que está no grupo certo.
        const porId = new Map();
        itens.querySelectorAll('.tk-item[id]').forEach(el => { if (!porId.has(el.id)) porId.set(el.id, []); porId.get(el.id).push(el); });
        porId.forEach(cop => {
            if (cop.length < 2) return;
            const donos = new Set(cop.map(el => el.dataset.dono || ''));
            const fica = (donos.size > 1 && !cop.some(el => el.dataset.abrindo)) ? cop[cop.length - 1] : cop[0];
            cop.forEach(el => {
                if (el === fica) return;
                if (el.getAttribute('aria-current') === 'true') fica.setAttribute('aria-current', 'true');
                el.remove();
            });
        });
        carimbarEspera();
        regrupar();   // §5.2: "Carregar mais", o miolo do Assumir e a FE-3 acima (idempotente: a 2ª chamada não muda o DOM)
        if (!est.carregandoAba) pintarBloco(true);
        aoMudarFns.forEach(fn => { try { fn(); } catch (err) { /* um ouvinte não derruba a lista */ } });   // D35 bloco H
    };

    // ---------- D35 v17 §5: títulos de grupo ----------
    // Fonte única: o <template id="tk-grupo-modelos">. Idempotente e síncrona (o MutationObserver do aoMudarLista a chama de novo e nada muda):
    // 1) para o 1º .tk-item de cada dono (ou o 1º de todos, na vista sem grupos) garante o título IMEDIATAMENTE antes dele (entra também num
    // #tk-fila-pag-N); 2) tira os títulos de grupo sem item e os duplicados (fica o 1º); 3) pinta a contagem (est.grupos; null = oculta).
    // Nunca escreve se já está certo (nextElementSibling / textContent iguais).
    // R-2 do parecer-d35-bloco-g: em QUALQUER finalizados o título é o neutro ("LIA · Finalizados"), como em Todos · Finalizados: "A LIA está
    // atendendo" / "a LIA passou para humano" seriam falsos sobre ticket finalizado.
    const semGrupos = () => est.grupos === null || est.situacao === 'finalizados';
    const tituloVista = () => (est.atendente === 'todos' ? nomeDa(est.situacao) : nomeDaVista());
    const regrupar = () => {
        if (!modelos || !itens) return;
        const primeiro = new Map();
        itens.querySelectorAll('.tk-item').forEach(el => {
            const g = semGrupos() ? 'vista' : (el.dataset.dono || '');
            if (g && !primeiro.has(g) && modelos.content.querySelector('[data-grupo="' + g + '"]')) primeiro.set(g, el);
        });
        const vistos = new Set();
        itens.querySelectorAll('.tk-fila-grupo').forEach(h => {
            const g = h.dataset.grupo;
            if (!primeiro.has(g) || vistos.has(g)) { h.remove(); return; }
            vistos.add(g);
        });
        primeiro.forEach((el, g) => {
            let h = itens.querySelector('.tk-fila-grupo[data-grupo="' + g + '"]');
            if (!h) h = modelos.content.querySelector('[data-grupo="' + g + '"]').cloneNode(true);
            if (el.previousElementSibling !== h) el.before(h);
            if (g === 'vista') { const tt = h.querySelector('.tk-grupo-tit'); const nv = tituloVista(); if (tt && tt.textContent !== nv) tt.textContent = nv; }
            const small = h.querySelector('[data-tk-grupo-n]');
            if (!small) return;
            const n = g === 'vista' ? est.total : (est.grupos ? est.grupos[g] : null);
            const ok = typeof n === 'number' && isFinite(n);
            if (small.hidden === ok) small.hidden = !ok;
            if (ok && small.textContent !== fmt(n)) small.textContent = fmt(n);
        });
    };

    // ---------- D14: relógio do selo de espera ----------
    // O servidor manda os segundos já decorridos (data-espera-seg) e a data curta (data-espera-desde); aqui só se soma o
    // tempo de tela (performance.now: sem fuso nem relógio do cliente). O tique troca SÓ o texto do .tk-espera-txt.
    const carimbarEspera = () => {
        if (!itens) return;
        const agora = performance.now();
        document.querySelectorAll(SELOS_ESPERA).forEach(el => { if (!esperaT0.has(el)) esperaT0.set(el, agora); });
    };
    const textoEspera = (seg, desde) => {
        if (seg < 3600) return t('espera_min', { n: Math.max(1, Math.floor(seg / 60)) });
        if (seg < 86400) return t('espera_h', { n: Math.floor(seg / 3600) });
        return t('espera_desde', { data: desde || '' });
    };
    const tique = () => {
        const agora = performance.now();
        document.querySelectorAll(SELOS_ESPERA).forEach(el => {
            if (!esperaT0.has(el)) { esperaT0.set(el, agora); return; }
            const base = parseInt(el.dataset.esperaSeg, 10);
            const txt = el.querySelector('.tk-espera-txt');
            if (isNaN(base) || !txt) return;
            const novo = textoEspera(base + Math.floor((agora - esperaT0.get(el)) / 1000), el.dataset.esperaDesde);
            if (txt.textContent !== novo) txt.textContent = novo;
        });
    };

    // ---------- chips: contagens ----------
    const pintarChip = (chip, n, falhouAgora) => {
        const caixa = chip.querySelector('.tk-chip-n');
        if (n === null || n === undefined) {
            // falha: mantém o número anterior se já havia (CA 26); senão, só o nome + title
            if (caixa.hidden && falhouAgora) { chip.dataset.contagem = 'erro'; chip.title = TXT_CONTAGEM_ERRO; }
            return;
        }
        chip.querySelector('.tk-chip-v').textContent = fmt(n);
        if (chip.dataset.aba === 'aguardando') chip.dataset.espera = n > 0 ? '1' : '0';   // D14 (o aplicarContagens corrige pela chave fixa, J-11)
        caixa.hidden = false;
        delete chip.dataset.contagem;
        chip.removeAttribute('title');
    };

    // ---------- D27: quantidade no "Atender o próximo" ----------
    // Comparável = nenhuma chave legada presente. Presente: nome igual com valor aparado não vazio (o último valor, como o PHP lê a
    // query) ou qualquer nome que comece por `k[` (o PHP junta em array e filtra). `period` = 'all' é ausente.
    const comparavel = () => {
        const p = new URLSearchParams(location.search);
        const nomes = Array.from(p.keys());
        return !CHAVES_LEGADAS.some(k => {
            if (nomes.some(nome => nome.startsWith(k + '['))) return true;
            const vs = p.getAll(k);
            if (!vs.length) return false;
            const v = String(vs[vs.length - 1]).replace(APARAR, '');
            return v !== '' && !(k === 'period' && v === 'all');
        });
    };
    const descrever = (texto) => {
        if (proximoDesc) proximoDesc.textContent = texto;
        if (texto) proximo.title = texto; else proximo.removeAttribute('title');
    };
    // Sem número (carregando ou não comparável): só "Atender o próximo →".
    const limparProximo = () => {
        if (!proximo) return;
        const pil = proximo.querySelector('.tk-proximo-n');
        if (pil) { pil.hidden = true; pil.textContent = ''; }
        proximo.dataset.disponiveis = '';
        delete proximo.dataset.contagem;
        descrever('');
    };
    // Mesma semântica do pintarChip: null = falha (mantém o anterior; sem anterior e falhouAgora → title/descrição de erro).
    const pintarProximo = (n, falhouAgora) => {
        if (!proximo || !comparavel()) return;
        const pil = proximo.querySelector('.tk-proximo-n');
        if (!pil) return;
        if (typeof n !== 'number' || !isFinite(n)) {
            if (pil.hidden && falhouAgora) { proximo.dataset.contagem = 'erro'; descrever(TXT_CONTAGEM_ERRO); }
            return;
        }
        pil.textContent = n > 99 ? '99+' : fmt(n);
        pil.hidden = false;
        proximo.dataset.disponiveis = n > 0 ? '1' : '0';
        delete proximo.dataset.contagem;
        descrever(n === 0 ? t('proximo_desc_0') : (n === 1 ? t('proximo_desc_1') : t('proximo_desc_n', { n: fmt(n) })));
    };

    // ---------- D24 A1: pulso do chip Esperando (d24-v02 §2) ----------
    // O CSS só anima com data-pulso="1" + data-espera="1" + aria-pressed="false" (e nunca no reduce). Aqui só se decide QUANDO ligar.
    let pulsoInicio = -Infinity;   // performance.now() do início do último pulso
    let pulsoPendente = false;     // subida com a aba do navegador escondida (no máximo 1)
    const tentarPulso = () => {
        const c = chipDa('aguardando');
        if (!c) return;
        if (document.visibilityState === 'hidden') { pulsoPendente = true; return; }   // pulsar escondido seria pulsar para ninguém
        // Descartado (não fica pendente): ativo, pulso em curso (a subida não estende) ou a menos de 30 s do último.
        if (c.getAttribute('aria-pressed') === 'true' || 'pulso' in c.dataset || performance.now() - pulsoInicio < PULSO_INTERVALO_MS) return;
        pulsoInicio = performance.now();
        c.dataset.pulso = '1';
        setTimeout(() => { delete c.dataset.pulso; }, PULSO_MS);   // nenhum episódio passa de 4,8 s
    };
    const pulsoAoVoltar = () => {
        if (document.visibilityState === 'hidden' || !pulsoPendente) return;
        pulsoPendente = false;
        tentarPulso();
    };

    // D35 v17 J-7/J-8/J-11 (E3 do d35-g.md §1.4): r.atendente / r.situacao (cada eixo × o outro ativo), r.grupos, comigo-novos, proximo e
    // aguardando-total (R-1: (todos, aguardando) fixo, para o pulso e o anúncio da D14/D24 com qualquer atendente).
    const aplicarContagens = (r) => {
        const ativos = [chipDa(est.atendente), chipDa(est.situacao)].filter(Boolean);
        const via = ativos.filter(c => inteiro(c));   // D18: só reajusta o ativo que estava inteiro (não puxa quem rolou)
        chips().forEach(c => { const m = r ? r[eixoDe(c)] : null; pintarChip(c, m && typeof m === 'object' ? m[c.dataset.aba] : null, true); });
        pintarProximo(r ? r['proximo'] : null, true);   // D27 + D31 (R-3): sem dono E assumível (sem treino da LIA); sem a chave = falha (d27)
        via.forEach(c => mostrarChip(c));
        // D14 (d14-v01 §5.5): só a SUBIDA é anunciada; a 1ª contagem da página não anuncia. D24 A1: a subida OU a 1ª contagem da página com
        // > 0 pulsa o chip. Falha nunca pulsa. Sem a chave fixa, vale situacao.aguardando, que só é comparável com Todos/Sem dono (J-11).
        let ne = null;
        if (r && typeof r['aguardando-total'] === 'number') { ne = r['aguardando-total']; esperaFixa = true; }
        else if (r && r.situacao && typeof r.situacao.aguardando === 'number' && (est.atendente === 'todos' || est.atendente === 'sem-dono')) ne = r.situacao.aguardando;
        if (ne !== null) {
            const subiu = esperaConhecida !== null && ne > esperaConhecida;
            if (subiu) anunciar(ne === 1 ? t('anuncio_1') : t('anuncio_n', { n: fmt(ne) }));
            if (subiu || (esperaConhecida === null && ne > 0 && pulsoDaPagina)) tentarPulso();
            esperaConhecida = ne;
            pulsoDaPagina = false;
            const ag = chipDa('aguardando');
            if (ag) ag.dataset.espera = ne > 0 ? '1' : '0';   // o pulso (CSS) exige data-espera=1: com Comigo ativo o chip mostra 0 e a fila tem gente
        }
        // D21: ponto e descrição do chip Comigo (`comigo-novos` não é aba; null/erro → ponto oculto, sem descrição).
        const cm = chipDa('comigo');
        if (cm) {
            const nn = r && typeof r['comigo-novos'] === 'number' ? r['comigo-novos'] : null;
            const txt = nn > 0 ? (nn === 1 ? t('novos_desc_1') : t('novos_desc_n', { n: fmt(nn) })) : '';
            cm.dataset.novos = nn > 0 ? '1' : '0';
            const desc = document.getElementById('tk-comigo-novos');
            if (desc) desc.textContent = txt;
            if (txt) cm.title = txt; else if (!cm.dataset.contagem) cm.removeAttribute('title');
            if (nn !== null) {
                if (novosConhecidos !== null && nn > novosConhecidos) anunciar(nn === 1 ? t('novos_anuncio_1') : t('novos_anuncio_n', { n: fmt(nn) }));
                novosConhecidos = nn;
            }
        }
        // sem busca, o total do cabeçalho acompanha o par ativo; com busca é o total da busca (não muda). Grupos: a falha mantém o anterior.
        if (r && busca() === '' && r.atendente && typeof r.atendente[est.atendente] === 'number') est.total = r.atendente[est.atendente];
        // F-2 do parecer-d35-bloco-g (D35-65, LICOES 118): com busca ativa o E3 NÃO escreve os grupos; vale a contagem do E-ABA, que já vem
        // com a busca (o E3 conta sem ela e o título mostraria 70 com 2 itens na lista).
        if (r && busca() === '' && 'grupos' in r && (r.grupos === null || typeof r.grupos === 'object')) est.grupos = r.grupos;
        fileiras().forEach(f => f.setAttribute('aria-busy', 'false'));
        if (!est.carregandoAba) { regrupar(); pintarBloco(true); }
    };

    // J-8 revisto (F-2, D35-65): o E3 vai sempre SEM busca (as fileiras contam sem ela, D04 CA 13). Com busca, os grupos vêm só do E-ABA,
    // e mandar o `search` aqui só custaria +4 contagens no servidor (d35-g §2.2) para um número que não se usa.
    const buscarContagens = () => getJSON(urls.contagens, query({ atendente: est.atendente, situacao: est.situacao, search: null }))
        .then(r => { aplicarContagens(r); return r; })
        .catch(e => { aplicarContagens(null); throw e; });

    // Ritmo das recontagens. Ação do próprio atendente (imediata) reconta na hora; evento do Pusher reconta no máximo a cada
    // CONTAGEM_MIN_MS, com a última sempre garantida (timer). Aba do navegador escondida não reconta: fica pendente para o retorno.
    let contagemUltima = 0;
    let contagemTimer = null;
    let contagemPendente = false;
    const contagemJa = () => {
        clearTimeout(contagemTimer);
        contagemTimer = null;
        contagemPendente = false;
        contagemUltima = Date.now();
        return buscarContagens();
    };
    const contagensNoRitmo = (imediata) => {
        if (imediata) return contagemJa();
        if (document.visibilityState === 'hidden') { contagemPendente = true; return Promise.resolve(null); }
        const falta = CONTAGEM_MIN_MS - (Date.now() - contagemUltima);
        if (falta <= 0) return contagemJa();
        if (!contagemTimer) {
            contagemTimer = setTimeout(() => {
                contagemTimer = null;
                if (document.visibilityState === 'hidden') { contagemPendente = true; return; }
                contagemJa().catch(() => {});
            }, falta);
        }
        return Promise.resolve(null);
    };
    const contagemAoVoltar = () => {
        if (document.visibilityState !== 'hidden' && contagemPendente) contagemJa().catch(() => {});
    };

    // ---------- estado vazio ----------
    // J-13 (§8.1, a mesma cadeia do blade): E-7 (Aguardando com dono) > E-1 (Abertos: o do atendente) > E-2 (Todos: o da situação) > E-3 (o par).
    const motivoVazio = () => est.vazioMotivo || ((est.situacao === 'aguardando' && ['lia', 'comigo', 'equipe'].indexOf(est.atendente) >= 0) ? 'aguardando-dono' : null);
    const textoVazio = () => {
        const termo = busca();
        if (termo) {
            return 'Nenhum ticket encontrado para “' + termo + '”' + (vista() !== 'todos:abertos' ? ' em ' + nomeDaVista() : '') + '.';
        }
        if (motivoVazio() === 'aguardando-dono') return t('vazio_dono');
        const ca = chipDa(est.atendente), cs = chipDa(est.situacao);
        if (est.situacao === 'abertos' && ca && ca.dataset.vazio) return ca.dataset.vazio;
        if (est.atendente === 'todos' && cs && cs.dataset.vazio) return cs.dataset.vazio;
        return t('vazio_par', { atendente: nomeDa(est.atendente), situacao: nomeDa(est.situacao) });
    };
    const conferirVazio = () => {
        const temItem = itens.querySelector('.tk-item');
        const p = itens.querySelector(':scope > .tk-fila-vazio');
        if (temItem && p) p.remove();
        if (!temItem && !p) {
            const novo = document.createElement('p');
            novo.className = 'tk-fila-vazio';
            novo.textContent = textoVazio();
            itens.prepend(novo);
        }
    };

    // ---------- pílula "N novos" ----------
    const pintarNovos = () => {
        if (est.novos <= 0) { novosBtn.hidden = true; return; }
        novosBtn.querySelector('.tk-novos-txt').textContent = est.novos === 1 ? '1 novo' : est.novos + ' novos';
        novosBtn.setAttribute('aria-label', est.novos === 1
            ? '1 ticket novo no topo da lista. Ir para o topo.'
            : est.novos + ' tickets novos no topo da lista. Ir para o topo.');
        novosBtn.hidden = false;
    };
    const zerarNovos = () => { est.novos = 0; pintarNovos(); };

    // ---------- troca de filtro (D35 v17 §4.2/§4.3) ----------
    // J-3: aria-pressed por fileira e o ativo de cada uma inteiro NA SUA fileira.
    const marcarChips = () => {
        chips().forEach(c => c.setAttribute('aria-pressed', (c.dataset.aba === est.atendente || c.dataset.aba === est.situacao) ? 'true' : 'false'));
        mostrarAtivos();
    };
    // §4.2 (lab talk.js:2463-2495): desligado liga; ligado ≠ Todos/Abertos desliga (→ Todos/Abertos); Todos/Abertos ligado: nada.
    const proximoPar = (c) => {
        const eixo = eixoDe(c), v = c.dataset.aba;
        if (eixo === 'atendente') return { atendente: v === est.atendente ? 'todos' : v, situacao: est.situacao };
        if (eixo === 'situacao') return { atendente: est.atendente, situacao: v === est.situacao ? 'abertos' : v };
        return null;
    };
    // J-5: atendente + situacao na URL e nos 2 hidden da busca; aba/lated (legado) saem.
    const trocarUrl = (par) => {
        const u = new URL(location.href);
        u.searchParams.set('atendente', par.atendente);
        u.searchParams.set('situacao', par.situacao);
        u.searchParams.delete('aba');
        u.searchParams.delete('lated');
        history.replaceState(history.state, '', u.toString());
        const ia = fila.querySelector('.tk-busca input[name="atendente"]'), is = fila.querySelector('.tk-busca input[name="situacao"]');
        if (ia) ia.value = par.atendente;
        if (is) is.value = par.situacao;
    };
    const esconderAviso = () => { aviso.hidden = true; };
    const pintarFila = () => { fila.dataset.atendente = est.atendente; fila.dataset.situacao = est.situacao; fila.dataset.modo = est.modo; };

    let abaAbort = null;
    const trocarFiltro = (par, focarChipNoFim) => {
        const anterior = est.carregada;   // o último par que está NA TELA (não o pendente de um clique anterior)
        const seq = ++seqAba;
        esconderAviso();
        zerarNovos();
        est.atendente = par.atendente;
        est.situacao = par.situacao;
        marcarChips();
        trocarUrl(par);
        est.carregandoAba = true;
        pintarBloco(false);
        const esq = setTimeout(() => { if (seq === seqAba) lista.setAttribute('aria-busy', 'true'); }, ESQ_MS);

        // cliques seguidos em chips: a troca anterior é cancelada (o seq já descartava a resposta, mas o navegador seguia esperando)
        if (abaAbort) abaAbort.abort();
        abaAbort = typeof AbortController === 'function' ? new AbortController() : null;

        return getJSON(urls.aba, query({ atendente: par.atendente, situacao: par.situacao }), abaAbort ? abaAbort.signal : undefined).then(r => {
            if (seq !== seqAba) return;   // resposta velha: descarta
            clearTimeout(esq);
            versaoLista++;
            est.carregada = { atendente: par.atendente, situacao: par.situacao };
            if (typeof r.modo === 'string') est.modo = r.modo;
            if (Array.isArray(r.donos)) est.donos = r.donos;
            est.grupos = (r.grupos === null || typeof r.grupos === 'object') ? r.grupos : {};
            est.vazioMotivo = typeof r.vazio_motivo === 'string' ? r.vazio_motivo : null;
            if (!esperaFixa) { esperaConhecida = null; pulsoDaPagina = false; }   // J-11: sem a chave fixa, a contagem da vista nova não é comparável
            pintarFila();
            itens.innerHTML = r.vazio ? '' : (r.itens || '');
            rodape.innerHTML = r.rodape || '';
            est.total = typeof r.total === 'number' ? r.total : null;
            est.carregandoAba = false;
            regrupar();   // §5.2: síncrona, logo depois do innerHTML
            if (busca() === '' && est.total !== null) { pintarChip(chipDa(par.atendente), est.total, false); pintarChip(chipDa(par.situacao), est.total, false); }
            // D31 (R-3) / J-15: a pílula NÃO é o total do chip. Só repinta com `proximo` numérico; senão fica como está.
            if (busca() === '' && typeof r.proximo === 'number') pintarProximo(r.proximo, false);
            mostrarAtivos();   // D18: o número do ativo alargou o chip
            conferirVazio();
            const ab = aberto();
            const el = ab ? document.getElementById('opportunity_' + ab) : null;
            if (el && itens.contains(el)) el.setAttribute('aria-current', 'true');
            lista.setAttribute('aria-busy', 'false');
            lista.scrollTop = 0;
            if (busca() === '') { const sub = bloco.querySelector('.tk-grupo-sub'); if (sub) sub.remove(); }   // D20: a busca foi desfeita
            pintarBloco(true);
            anunciar(nomeDaVista() + ': ' + fmt(contarX()) + ' de ' + (est.total === null ? '?' : fmt(est.total)) + ' tickets.');
            if (focarChipNoFim) { const fc = chipDa(focarChipNoFim === true ? par.situacao : focarChipNoFim); if (fc) fc.focus(); }
        }).catch(() => {
            if (seq !== seqAba) return;
            clearTimeout(esq);
            est.atendente = anterior.atendente;
            est.situacao = anterior.situacao;
            est.carregandoAba = false;
            marcarChips();
            trocarUrl(anterior);
            lista.setAttribute('aria-busy', 'false');   // a lista anterior reaparece (mesmos nós)
            pintarBloco(true);
            aviso.querySelector('.tk-fila-aviso-txt').textContent = t('aba_erro', { aba: nomeDaVista(par) });
            aviso.dataset.filtro = par.atendente + ':' + par.situacao;
            aviso.hidden = false;
        });
    };

    // ---------- sincronização (lote) ----------
    // a vem antes de b na ordem do servidor: created DESC, id DESC, created nulo por último.
    // D14/D29: em "Esperando" (Aguardando) a ordem é CRESCENTE pela chave "<grupo>|<K>" comparada como string, id ASC no empate
    // (= ORDER BY (lia_handoff_at IS NULL), COALESCE(lia_handoff_at, date_client_last_comment), id). O `created` do E-SYNC já a traz.
    // D35 v17 J-10: por est.modo. grupos → donos.indexOf(dono) ASC (dono desconhecido no fim) e, no empate, a D21; aguardando → a D29;
    // corrida → a D21.
    const posDono = (d) => { const i = est.donos.indexOf(d || ''); return i < 0 ? est.donos.length : i; };
    const antesDe = (a, b) => {
        if (est.modo === 'grupos') { const da = posDono(a.dono), db = posDono(b.dono); if (da !== db) return da < db; }
        const asc = est.modo === 'aguardando';
        if (a.created && b.created) {
            if (a.created !== b.created) return asc ? a.created < b.created : a.created > b.created;
            return asc ? a.id < b.id : a.id > b.id;
        }
        if (a.created && !b.created) return true;
        if (!a.created && b.created) return false;
        return a.id > b.id;
    };
    // D21: a chave de ordem é o contato do cliente (data-contato); na Esperando, a chave composta "<grupo>|<K>" da D29 (data-desde,
    // ASC). O nome `created` do E-SYNC (`it.ordem.created`) é mantido pelo servidor e já traz a chave da aba (contrato-d21 §3).
    const chaveAttr = () => (est.modo === 'aguardando' ? 'desde' : 'contato');
    const idDe = (el) => parseInt(el.id.replace('opportunity_', ''), 10) || 0;
    const ordemDe = (el) => ({ created: el.dataset[chaveAttr()] || null, id: idDe(el), dono: el.dataset.dono || null });
    const haMais = () => !!rodape.querySelector('.bt-ajax');

    // D29 F2 v03 passo 4: cursor do "Carregar mais" = o último item SERVIDO, que pode já ter saído do DOM (LICOES 74). Lido do data-ajax
    // do botão (rodapé normal, de erro e a reserva levam a mesma URL com antes_de/antes_id). antes_de sem "|" (botão desenhado antes do
    // deploy da D29) = "0|" + data, a mesma leitura do servidor (TicketContato::aguardaCursor). null = ilegível (sem botão, URL sem
    // antes_de ou sem antes_id inteiro positivo). `emVoo` = botão disabled pelo ajaxFunction (LICOES 56): a página seguinte pode ter sido
    // consultada antes de a chave mudar e não trazer o item (parecer-d29-php-v03 §2, R-C).
    const cursorDoBotao = () => {
        const b = rodape.querySelector('.tk-mais.bt-ajax');
        if (!b) return null;
        let p;
        try { p = new URL(b.dataset.ajax || '', location.href).searchParams; } catch (err) { return null; }
        const de = p.get('antes_de') || '', id = p.get('antes_id') || '';
        if (de === '' || !/^[1-9]\d*$/.test(id)) return null;
        // J-16: no modo grupos o cursor tem o dono (antes_dono); fora dele, null. F-1 do parecer-d35-bloco-g: o prefixo legado "0|" é da
        // chave da Aguardando (D29) e só vale nela; nos outros modos a data vai crua (a mesma comparação do servidor).
        const created = (est.modo === 'aguardando' && de.indexOf('|') < 0) ? '0|' + de : de;
        return { created: created, id: parseInt(id, 10), dono: p.get('antes_dono') || null, emVoo: !!b.disabled };
    };
    // Depois de todo item presente (mesmo nó; sem mexer se já é o último). Antes do placeholder vazio da página seguinte.
    // R1 (parecer-d29-front-v01): sem nenhum item, entra ANTES do 1º placeholder (#tk-fila-pag-N, o mais externo: tudo que o "Carregar
    // mais" ainda trouxer cai dentro dele), nunca depois; sem placeholder, no começo da lista.
    const fimDoDom = (no) => {
        const atuais = Array.from(itens.querySelectorAll('.tk-item')).filter(el => el !== no);
        if (!atuais.length) {
            if (no.isConnected) return;
            const ph = itens.querySelector('.tk-fila-pag');
            if (ph) ph.before(no); else itens.prepend(no);
            return;
        }
        const u = atuais[atuais.length - 1];
        if (u.nextElementSibling !== no || !no.isConnected) u.after(no);
    };
    const ordemNova = (ordem) => ({ created: ordem && ordem.created ? String(ordem.created) : null, id: ordem ? parseInt(ordem.id, 10) || 0 : 0, dono: ordem && ordem.dono ? String(ordem.dono) : null });

    // Primeiro item visível da lista (para manter a leitura parada quando algo entra acima).
    const primeiroVisivel = () => {
        const topo = lista.getBoundingClientRect().top;
        return Array.from(itens.querySelectorAll('.tk-item')).find(it => it.getBoundingClientRect().bottom > topo) || null;
    };

    // Posição de um item pela ordem do servidor: antes do 1º que ele precede; sem alvo e sem "Carregar mais", no fim; sem alvo e com
    // "Carregar mais", devolve false e NÃO mexe no nó (quem decide é o chamador: inserir / moverAgora, D29 F2 v03). Não ancora: quem
    // ancora é o lote (D21, v03 §4).
    const posicionar = (no, ordem) => {
        const nova = { created: ordem && ordem.created ? ordem.created : null, id: ordem ? parseInt(ordem.id, 10) || 0 : 0, dono: (ordem && ordem.dono) || no.dataset.dono || null };
        const atuais = Array.from(itens.querySelectorAll('.tk-item')).filter(el => el !== no);
        const alvo = atuais.find(el => antesDe(nova, ordemDe(el)));
        if (alvo) { if (alvo.previousElementSibling !== no || !no.isConnected) alvo.before(no); return true; }
        if (!haMais()) { if (atuais.length) atuais[atuais.length - 1].after(no); else itens.append(no); return true; }
        return false;
    };

    const inserir = (artigoHtml, ordem) => {
        const novo = fragmento(artigoHtml).querySelector('.tk-item');
        if (!novo || document.getElementById(novo.id)) return null;   // nunca duplica
        if (posicionar(novo, ordem)) return novo;
        // D29 (opcional do §v03-2, buraco pré-existente da D04/D21), só na Aguardando: sem alvo e com "Carregar mais", o item novo que vem
        // ANTES do cursor nunca seria trazido por ele → entra no fim do DOM. Depois do cursor, ou cursor ilegível: não insere (o cursor o
        // traz), como sempre foi. Página em voo não importa aqui: antes do cursor, nenhuma página o traz.
        // F-1 do parecer-d35-bloco-g (D35-65): vale em TODO modo. No modo grupos o dono entra na chave (LICOES 117).
        const cur = cursorDoBotao();
        if (!cur || antesDe(cur, ordemNova(ordem))) return null;
        fimDoDom(novo);
        return novo;
    };

    // D21 (v03 §4 B1): âncora do lote inteiro. Referência = 1º item visível que NÃO está no lote (um item do lote pode subir e levar
    // a leitura junto: salto de 372px medido pelo revisor). Com scrollTop 0 não há âncora: no topo, a leitura é o topo.
    const ancorar = (ids) => {
        if (lista.scrollTop <= 0) return null;
        const todos = Array.from(itens.querySelectorAll('.tk-item'));
        const pv = primeiroVisivel();
        const i0 = pv ? todos.indexOf(pv) : -1;
        if (i0 < 0) return null;
        const ref = todos.slice(i0).find(el => !ids.has(idDe(el)));
        return ref ? { ref, topo: ref.getBoundingClientRect().top } : null;
    };
    const restaurar = (a) => {
        if (!a || !a.ref.isConnected) return;
        const delta = a.ref.getBoundingClientRect().top - a.topo;
        if (delta) lista.scrollTop += delta;
    };
    // Pílula "N novos": item inserido/movido que terminou acima da área visível (depois da âncora).
    const contarAcima = (nos) => {
        const topo = lista.getBoundingClientRect().top;
        nos.forEach(no => {
            if (!no.isConnected || lista.scrollTop <= 0 || no.getBoundingClientRect().bottom > topo + 1) return;
            est.novos++;
            pintarNovos();
            if (!loteAnunciado) { loteAnunciado = true; anunciar(est.novos + (est.novos === 1 ? ' ticket novo no topo.' : ' tickets novos no topo.')); }
        });
    };

    // D21 (v01 §4.4): item cuja chave mudou sobe para a posição nova (MESMO nó: aria-current e handlers preservados). Adiado enquanto
    // o ponteiro está sobre ele, o foco está dentro, o Assumir dele está em voo ou a abertura dele está em andamento.
    // R1 (parecer-d21-front, v01 §4.4): o MIOLO é trocado sempre, mesmo sob foco/hover; o foco volta ao elemento equivalente do
    // miolo novo (mesma classe de papel; senão, o botão do item). Só a POSIÇÃO espera.
    const pendentesMover = new Map();   // id → { ordem }
    const PAPEIS_FOCO = ['tk-item-abrir', 'tk-assumir'];
    const trocarMiolo = (el, html) => {
        const ativo = document.activeElement;
        const dentro = !!ativo && ativo !== el && el.contains(ativo);
        const papel = dentro ? PAPEIS_FOCO.find(c => ativo.classList.contains(c)) : null;
        escritosPelaSync.add(el);
        el.innerHTML = html;
        if (!dentro) return;
        const alvo = (papel && el.querySelector('.' + papel)) || el.querySelector('.tk-item-abrir');
        if (alvo && !alvo.disabled) alvo.focus({ preventScroll: true });
    };
    const sobOUsuario = (el) => el.matches(':hover') || el.contains(document.activeElement);
    const bloqueado = (el) => sobOUsuario(el) || assumidos.has(idDe(el)) || !!el.dataset.abrindo;
    const aplicarChave = (el, ordem) => {
        const k = ordem && ordem.created ? String(ordem.created) : '';
        if (k) el.dataset[chaveAttr()] = k; else delete el.dataset[chaveAttr()];
        if (ordem && ordem.dono) el.dataset.dono = String(ordem.dono);   // J-17: o grupo de destino (Assumir em Todos muda o grupo, não a data)
    };
    // D29 F2 v03 (04-php/d29.md §v03-2): nó que JÁ está na lista e que o bloqueado() não adiou.
    //   1-3. chave nova; com alvo, antes dele; sem alvo e sem "Carregar mais", no fim (posicionar, como antes).
    //   4. sem alvo e com "Carregar mais" (só na Aguardando; nas abas DESC chave que sobe sempre tem alvo): compara com o cursor do botão
    //      pelo MESMO antesDe. Depois do cursor → sai (o keyset o traz no lugar certo, sem cópia para o FE-3). Antes do cursor ou igual →
    //      fim do DOM (dentro da faixa servida; nenhuma página o traz de novo). Cursor ilegível ou botão disabled (R-C) → fim do DOM: errar
    //      a posição é melhor que esconder o item; se a página em voo também o trouxer, o FE-3 apaga a cópia da página.
    //   5. exceções da saída: ticket aberto / abertura em andamento, e "Atender o próximo" em curso (id em adiadosProximo, que o
    //      soltarAtendendo devolve ao lote). Ficam no lugar com a chave ANTIGA: a ordem do DOM continua coerente para os vizinhos, e a sync
    //      seguinte vê a chave mudada e reaplica esta regra (com a nova gravada, o `mudou` seria falso e nada mais aconteceria).
    //      R-A (parecer-d29-php-v03): o "Assumir em andamento" não entra aqui; o bloqueado() já o adiou antes (pendentesMover).
    // F-1 do parecer-d35-bloco-g (D35-65): a regra "sem alvo + Carregar mais" vale em TODO modo, e não só na Aguardando. A suposição "nas abas
    // DESC a chave só sobe" caiu com o dono na chave (modo grupos): um item que vai para um grupo AINDA NÃO CARREGADO (sem-dono → equipe,
    // lia → sem-dono) não tem alvo. Compara com o cursor INTEIRO (antes_dono + antes_de + antes_id, a ordem do servidor): depois dele sai do DOM
    // (o "Carregar mais" o traz no grupo certo); antes dele, fim do DOM (o regrupar põe o título). O aberto/abrindo e o do "Atender o próximo"
    // nunca somem: ficam no lugar com a chave E o dono antigos (exceção da D29; a sync seguinte reaplica).
    const restaurarChave = (el, antiga, donoAntigo) => {
        if (antiga) el.dataset[chaveAttr()] = antiga; else delete el.dataset[chaveAttr()];
        if (donoAntigo) el.dataset.dono = donoAntigo; else delete el.dataset.dono;
    };
    const moverAgora = (el, ordem) => {
        const antiga = el.dataset[chaveAttr()];
        const donoAntigo = el.dataset.dono;
        aplicarChave(el, ordem);
        if (posicionar(el, ordem)) return;
        const cur = cursorDoBotao();
        if (!cur || cur.emVoo || !antesDe(cur, ordemNova(ordem))) { fimDoDom(el); return; }
        const id = idDe(el);
        if (id === aberto() || el.dataset.abrindo) { restaurarChave(el, antiga, donoAntigo); return; }
        if (atendendo) { restaurarChave(el, antiga, donoAntigo); adiadosProximo.add(id); return; }
        el.remove();
    };
    // Aplica a posição que ficou pendente. Devolve true se o nó foi reposicionado.
    const aplicarPendente = (el, p) => {
        if (p.ordem) { moverAgora(el, p.ordem); return true; }
        return false;
    };
    const armarSoltura = (el) => {
        const h = () => setTimeout(() => soltarPendente(el), 0);   // depois de o foco/ponteiro realmente sair
        el.addEventListener('mouseleave', h, { once: true });
        el.addEventListener('focusout', h, { once: true });
    };
    const soltarPendente = (el) => {
        const id = idDe(el);
        if (!pendentesMover.has(id) || !el.isConnected || !itens.contains(el)) { pendentesMover.delete(id); return; }
        if (bloqueado(el)) { armarSoltura(el); return; }   // focusout dentro do próprio item, ou Assumir ainda em voo
        const p = pendentesMover.get(id);
        pendentesMover.delete(id);
        const a = ancorar(new Set([id]));
        const moveu = aplicarPendente(el, p);
        regrupar();   // §5.2: antes do restaurar (um título que nasce acima da leitura entra na conta da âncora)
        restaurar(a);
        if (moveu) contarAcima([el]);
    };
    const adiar = (el, p) => {
        const id = idDe(el);
        const ja = pendentesMover.has(id);
        const ant = ja ? pendentesMover.get(id) : {};
        pendentesMover.set(id, { ordem: p.ordem || ant.ordem });
        if (!ja) armarSoltura(el);
    };

    const aplicarSync = (r, versao) => {
        // lista mudou no meio, ou há troca de aba pendente (a tela ainda mostra a lista antiga): descarta
        if (versao !== versaoLista || est.carregandoAba || !r || r.aba !== vista()) return false;   // J-9
        const ab = aberto();
        const lote = new Set((r.itens || []).map(it => parseInt(it.id, 10)));
        const ancora = ancorar(lote);   // D21: âncora do lote inteiro, referência fora dele
        const mexidos = [];
        // D21: movimentos adiados de lotes anteriores (fora deste lote) tentam de novo agora
        Array.from(pendentesMover.keys()).filter(id => !lote.has(id)).forEach(id => {
            const el = document.getElementById('opportunity_' + id);
            if (!el || !itens.contains(el)) { pendentesMover.delete(id); return; }
            if (bloqueado(el)) return;
            const p = pendentesMover.get(id);
            pendentesMover.delete(id);
            if (aplicarPendente(el, p)) mexidos.push(el);
        });
        (r.itens || []).forEach(it => {
            const el = document.getElementById('opportunity_' + it.id);
            const naLista = el && itens.contains(el);
            if (it.pertence && naLista) {
                // mesmo <article>: aria-current preservado (CA 23). R1: troca mesmo sob foco/hover, devolvendo o foco
                if (it.miolo) trocarMiolo(el, it.miolo);
                delete el.dataset.fora;
                // D21: a chave mudou → sobe (ou adia sob hover/foco/Assumir/abertura)
                const nova = it.ordem && it.ordem.created ? String(it.ordem.created) : '';
                const donoNovo = it.ordem && it.ordem.dono ? String(it.ordem.dono) : '';
                const mudou = !!it.ordem && (nova !== (el.dataset[chaveAttr()] || '') || (donoNovo !== '' && donoNovo !== (el.dataset.dono || '')));   // J-17
                if (mudou && bloqueado(el)) {
                    adiar(el, { ordem: it.ordem });
                } else if (mudou) {
                    pendentesMover.delete(parseInt(it.id, 10));
                    moverAgora(el, it.ordem);
                    mexidos.push(el);
                }
            } else if (!it.pertence && naLista) {
                if (it.id === ab || el.dataset.abrindo) {   // aberto, ou abertura em andamento (D08 R-2)
                    if (it.fora && it.miolo) trocarMiolo(el, it.miolo);
                    el.dataset.fora = 'true';
                } else if (assumidos.has(it.id)) {
                    // D08 R-1: Assumir em andamento — não remove (a resposta do P3 precisa do item para abrir o ticket).
                    adiados.add(it.id);
                } else if (atendendo) {
                    adiadosProximo.add(it.id);   // D09 F-2 / D35 v17 J-14: em QUALQUER vista (o assumido sai de Sem dono, Aguardando, Novo…)
                } else {
                    el.remove();
                }
            } else if (it.pertence && !naLista && it.artigo) {
                const no = inserir(it.artigo, it.ordem);
                if (no) mexidos.push(no);
            }
        });
        regrupar();   // §5.2: antes do restaurar
        restaurar(ancora);
        contarAcima(mexidos);
        conferirVazio();
        pintarBloco(true);
        return true;
    };

    // Devolve ids ao lote sem criar nova espera (R-1: sincronização descartada não perde os ids).
    const devolverAoLote = (ids) => {
        ids.forEach(id => { if (id) lote.add(id); });
        if (lote.size && !loteTimer) loteTimer = setTimeout(descarregarLote, LOTE_MS);
    };

    const sincronizarIds = (ids) => {
        if (!ids.length) return Promise.resolve(null);
        const versao = versaoLista;
        const ab = abrindo() || aberto();   // a abertura em andamento ganha o miolo com o selo "fora" (D08 R-2)
        return getJSON(urls.sync, query({ atendente: est.atendente, situacao: est.situacao, ids: ids.join(','), aberto: ab || null }))   // J-6
            .then(r => {
                // descartada (troca de aba pendente ou concluída no meio): os ids voltam ao próximo lote (R-1)
                if (!aplicarSync(r, versao)) devolverAoLote(ids);
                return r;
            });
    };

    const descarregarLote = () => {
        loteTimer = null;
        const todos = Array.from(lote);
        const ids = todos.slice(0, SYNC_MAX);
        lote = new Set(todos.slice(SYNC_MAX));   // excedente vai para o próximo lote
        const espera = loteEspera;
        loteEspera = [];
        loteAnunciado = false;
        const imediata = loteImediato;
        loteImediato = false;
        est.sincronizando = true;
        if (lote.size) loteTimer = setTimeout(descarregarLote, LOTE_MS);

        Promise.all([contagensNoRitmo(imediata), sincronizarIds(ids)])
            .then(() => { est.sincronizando = false; espera.forEach(p => p.resolve()); })
            .catch(e => { est.sincronizando = false; espera.forEach(p => p.reject(e)); });   // a tela fica como estava (CA 26)
    };

    // imediata: o lote nasce de ação deste atendente (ou de reconexão) e reconta na hora; o padrão (evento de outro) segue o ritmo.
    let loteImediato = false;
    const enfileirar = (ids, imediata = true) => new Promise((resolve, reject) => {
        if (imediata) loteImediato = true;
        ids.forEach(id => { if (id) lote.add(id); });
        loteEspera.push({ resolve, reject });
        if (!loteTimer) loteTimer = setTimeout(descarregarLote, LOTE_MS);
    });

    // D35 bloco H (d35-v20 §5.4): o PainelOlho ouve 'tk:ticket-evento' no document (o painel do ticket se recarrega no lote dele).
    const avisarTicket = (id) => { try { document.dispatchEvent(new CustomEvent('tk:ticket-evento', { detail: { ticket_id: id } })); } catch (err) { /* nunca derruba a sync */ } };
    // D35 bloco H (§5.1): o trilho da 5ª janela é refeito a cada mudança da lista (window.tkFila.aoMudar(fn)).
    const aoMudarFns = [];

    // Mesmo caminho para o Echo e para o gancho de teste (CA 30).
    const receberEvento = (nome, payload) => {
        payload = payload || {};
        // payload.local = a própria tela avisando de uma ação deste atendente (FaixaFinalizar): reconta na hora.
        const imediata = payload.local === true;
        if (nome === 'LiaMessageEvent') {
            // 'unread-messages' = alguém abriu um chat (zerou não lidas): nenhum ticket muda de aba nem de contagem.
            if (payload.action === 'update-event' || payload.action === 'unread-messages') return Promise.resolve();
            const t = payload.chatMessage && payload.chatMessage.chat ? parseInt(payload.chatMessage.chat.ticket_id, 10) : 0;
            if (t > 0) avisarTicket(t);   // D35 bloco H (§5.4)
            return enfileirar(t > 0 ? [t] : [], imediata);   // sem ticket: só as contagens
        }
        if (nome === 'LiaTicketEvent') {
            const t = parseInt(payload.ticket_id, 10);
            if (t > 0) avisarTicket(t);   // D35 bloco H (§5.4): a 5ª janela recarrega o painel deste ticket
            if (t > 0) agendarChecagemCamada(t);   // D19: só o LiaTicketEvent muda o dono
            // D24 A3: transbordo (só a transição real emite 'lia-handoff'). Acréscimo: a sincronização abaixo não muda.
            if (t > 0 && payload.action === 'lia-handoff' && fila.dataset.avisoTransbordo === '1') {
                try { AvisoTransbordo.avisar(t); } catch (err) { /* o aviso nunca derruba a sincronização */ }
            }
            return enfileirar(t > 0 ? [t] : [], imediata);
        }
        return Promise.resolve();
    };

    // Reconexão / bfcache: contagens + página 1 da aba ativa, sem pular a leitura (os novos entram pela inserção).
    const sincronizacaoCompleta = () => getJSON(urls.aba, query({ atendente: est.atendente, situacao: est.situacao })).then(r => {
        const naPagina = Array.from(fragmento(r.itens).querySelectorAll('.tk-item'))
            .map(el => parseInt(el.id.replace('opportunity_', ''), 10)).filter(Boolean);
        const carregados = Array.from(itens.querySelectorAll('.tk-item'))
            .map(el => parseInt(el.id.replace('opportunity_', ''), 10)).filter(Boolean);
        const novos = naPagina.filter(id => carregados.indexOf(id) < 0);
        const ids = novos.concat(carregados.filter(id => novos.indexOf(id) < 0)).slice(0, SYNC_MAX);
        return enfileirar(ids);
    }).catch(() => enfileirar([]));

    // ---------- D17: sair do detalhe (a guarda mora no SaidaDetalhe; aqui só o foco por origem) ----------
    // Foco por origem (d17-v02 §3 + d17-v03 §2). `el` = o chip clicado, o "Tentar de novo" ou o "×".
    const focar = (el) => { if (el && el.isConnected) el.focus({ preventScroll: true }); };
    const focoConfirmado = (origem, el) => {
        if (origem === 'chip') {
            const a = document.activeElement;
            if (!a || a === document.body || !a.isConnected || a.closest('.swal2-container')) focar(el);
        } else if (origem === 'tentar') {
            const pa = (aviso.dataset.filtro || '').split(':');
            focar(chipDa(pa[1] && pa[1] !== est.situacao ? pa[1] : pa[0]));
        }   // 'limpar': o chamador foca o campo depois do true
    };
    const sair = (origem, el) => SaidaDetalhe.sair(origem, el, { aoConfirmar: focoConfirmado });

    // ---------- D20: limpar a busca ----------
    const haBusca = () => (campo ? campo.value !== '' : false) || busca() !== '';
    const sincLimpar = () => { if (limpar) limpar.hidden = !haBusca(); };
    const limparBusca = () => {
        if (busca() === '') {   // texto só digitado: a lista não muda → sem guarda (d17-v02 §1)
            campo.value = '';
            sincLimpar();
            campo.focus();
            return;
        }
        sair('limpar', limpar).then((ok) => {
            if (!ok) return;    // nada no campo, na URL nem no "×"; o foco é da função
            campo.value = '';
            const u = new URL(location.href);
            u.searchParams.delete('search');
            history.replaceState(history.state, '', u.toString());   // antes do trocarFiltro: o query() lê a URL
            sincLimpar();
            campo.focus();
            trocarFiltro({ atendente: est.atendente, situacao: est.situacao }, false);
        });
    };

    // ---------- D19: camada "Assumir" ----------
    let camadaArmada = null;   // { id, teto, vigia } enquanto o Assumir da camada está em voo
    let camadaChecagem = null; // { id, timer } checagem agendada (janela do lote)
    const camadaLivre = (id) => document.querySelector('.tk-camada[data-ticket="' + id + '"][data-estado="livre"]');

    const desarmarCamada = () => {
        if (!camadaArmada) return;
        clearTimeout(camadaArmada.teto);
        if (camadaArmada.vigia) camadaArmada.vigia.disconnect();
        camadaArmada = null;
    };
    // Arma no clique (document, sem preventDefault, como o armarAtendendo). Desarma: (a) detalhe trocado (observer do .open-ticket-detail),
    // (b) o botão perde o `disabled` sem o detalhe ter sido trocado (o .bt-ajax terminou em erro), (c) teto de 60 s.
    const armarCamada = (e) => {
        const btn = e.target instanceof Element ? e.target.closest('.tk-camada .tk-camada-assumir') : null;
        if (!btn) return;   // sem checar `disabled`: o handler delegado do .bt-ajax (app.js, registrado antes) já desabilitou o botão
        const cam = btn.closest('.tk-camada');
        const id = parseInt(cam && cam.dataset.ticket, 10);
        if (!id) return;
        desarmarCamada();
        const vigia = new MutationObserver(() => {
            if (btn.disabled) return;
            setTimeout(() => {   // depois do observer do detalhe (que desarma pelo caminho a)
                if (camadaArmada && camadaArmada.id === id && btn.isConnected && !btn.disabled) desarmarCamada();   // (b): sem mover o foco
            }, 0);
        });
        vigia.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
        camadaArmada = { id, vigia, teto: setTimeout(desarmarCamada, CAMADA_TETO_MS) };
    };

    const mudarCamada = (cam) => {
        const livre = cam.querySelector('[data-camada="livre"]');
        const mudou = cam.querySelector('[data-camada="mudou"]');
        if (!livre || !mudou) return;
        const tinhaFoco = !!document.activeElement && document.activeElement.closest('.tk-camada-assumir') !== null && cam.contains(document.activeElement);
        cam.dataset.estado = 'mudou';
        mudou.hidden = false;
        livre.hidden = true;
        if (tinhaFoco) { const re = cam.querySelector('.tk-camada-reabrir'); if (re) re.focus({ preventScroll: true }); }
    };

    // d19-v02 §3.1 (quando) + §3.2/v03 §2 (como): uma checagem por janela de 1,5 s, query montada à mão = exatamente {aba, ids}.
    const agendarChecagemCamada = (id) => {
        const btn = document.querySelector('.tk-camada[data-ticket="' + id + '"] .tk-camada-assumir');
        if (id !== aberto() || !camadaLivre(id) || camadaArmada || !btn || btn.disabled) return;
        if (camadaChecagem && camadaChecagem.id === id) return;   // já agendada nesta janela
        if (camadaChecagem) clearTimeout(camadaChecagem.timer);
        camadaChecagem = { id, timer: setTimeout(() => {
            camadaChecagem = null;
            if (id !== aberto() || !camadaLivre(id) || camadaArmada) return;
            getJSON(urls.sync, 'aba=sem-dono&ids=' + encodeURIComponent(id)).then((r) => {
                if (camadaArmada) return;   // o clique veio depois de a checagem sair: descarta (v02 §3.1)
                const cam = camadaLivre(id);
                if (!cam || id !== aberto()) return;
                const it = (r && Array.isArray(r.itens)) ? (r.itens.find(x => parseInt(x.id, 10) === id) || r.itens[0]) : null;
                if (it && it.pertence === false) mudarCamada(cam);
            }).catch(() => { /* nada muda, sem mensagem: a guarda real é o only_if_unassigned */ });
        }, LOTE_MS) };
    };

    // ---------- Pusher ----------
    const aoTicket = (e) => { receberEvento('LiaTicketEvent', e).catch(() => {}); };
    const aoMensagem = (e) => { receberEvento('LiaMessageEvent', e).catch(() => {}); };

    const assinar = () => {
        if (typeof window.Echo === 'undefined' || typeof client_name === 'undefined' || !client_name) return;
        try {
            if (canal) { canal.stopListening('LiaTicketEvent', aoTicket); canal.stopListening('LiaMessageEvent', aoMensagem); }   // só os próprios handlers
            canal = window.Echo.private('lia.' + client_name);
            canal.listen('LiaTicketEvent', aoTicket).listen('LiaMessageEvent', aoMensagem);
        } catch (err) { canal = null; }   // Pusher indisponível (local): fila estática, sem mensagem
    };

    const vigiarConexao = () => {
        try {
            const con = window.Echo.connector.pusher.connection;
            jaConectou = con.state === 'connected';
            con.bind('state_change', (s) => {
                if (s.current !== 'connected') return;
                if (jaConectou && s.previous !== 'connected') sincronizacaoCompleta();
                jaConectou = true;
            });
        } catch (err) { /* sem Pusher */ }
    };

    // ---------- init ----------
    return {
        init: function () {
            fila = document.getElementById('tk-fila');
            if (!fila || !fila.dataset.urlAba) return;   // só na tela de tickets nova (D04)
            lista = document.getElementById('tk-fila-lista');
            itens = document.getElementById('tk-fila-itens');
            rodape = document.getElementById('tk-fila-rodape');
            bloco = document.getElementById('tk-bloco');
            aviso = document.getElementById('tk-fila-aviso');
            status = document.getElementById('tk-fila-status');
            cabeca = fila.querySelector('.tk-fila-head') || fila;
            modelos = document.getElementById('tk-grupo-modelos');
            try { T = JSON.parse(fila.dataset.textos || '{}') || {}; } catch (err) { T = {}; }
            novosBtn = fila.querySelector('.tk-novos');
            urls = { aba: fila.dataset.urlAba, contagens: fila.dataset.urlContagens, sync: fila.dataset.urlSync };
            // J-1: o par, o modo, a ordem dos grupos e as contagens de grupo da carga (E1). data-grupos: null = vista sem grupos.
            est.atendente = fila.dataset.atendente || 'todos';
            est.situacao = fila.dataset.situacao || 'abertos';
            est.modo = fila.dataset.modo || 'grupos';
            try { const d = JSON.parse(fila.dataset.donos || 'null'); if (Array.isArray(d)) est.donos = d; } catch (err) { /* fica a ordem padrão */ }
            try { const g = JSON.parse(fila.dataset.grupos || '{}'); est.grupos = (g === null || typeof g === 'object') ? g : {}; } catch (err) { est.grupos = {}; }
            est.carregada = { atendente: est.atendente, situacao: est.situacao };
            const tot = bloco.querySelector('[data-tk-total]');
            est.total = tot && tot.textContent.trim() !== '' ? parseInt(tot.textContent.replace(/\D/g, ''), 10) : null;

            new MutationObserver(aoMudarLista).observe(itens, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-abrindo'] });
            document.addEventListener('click', armarAtendendo);   // D09 F-2 (sem preventDefault)
            document.addEventListener('click', marcarAssumir);   // antes do SweetAlert; sem preventDefault
            document.addEventListener('click', armarCamada);     // D19 (sem preventDefault: o .bt-ajax segue)

            // Item "fora deste filtro" sai quando outro ticket é aberto (o FilaSelecao já moveu o aria-current;
            // este observer é criado depois do dele, então roda depois).
            const detalhe = document.querySelector('.open-ticket-detail');
            if (detalhe) {
                new MutationObserver(() => {
                    itens.querySelectorAll('.tk-item[data-fora]:not([aria-current="true"])').forEach(el => el.remove());
                    conferirVazio();
                    soltarAtendendo();   // D09 F-2: o detalhe chegou; a sync seguinte marca o assumido como "fora" 
                    carimbarEspera();    // D19: selo de espera da camada entra no tique
                    if (camadaArmada) {  // D19 (a): o Assumir da camada redesenhou o detalhe
                        const id = camadaArmada.id;
                        desarmarCamada();
                        enfileirar([id]).catch(() => {});
                        const f = document.querySelector('.tk-faixa');
                        if (f) f.focus({ preventScroll: true });
                    }
                }).observe(detalhe, { childList: true });
            }

            cabeca.addEventListener('click', (e) => {
                const c = e.target instanceof Element ? e.target.closest('.tk-chip[data-aba]') : null;
                if (!c) return;
                // §4.2 / J-4: o par seguinte (ligado ≠ Todos/Abertos desliga — novo: a d18-v02 §2 tratava o ativo como "não gatilho", R-8).
                // Par igual (Todos/Abertos ligado) não é gatilho da D17: só mostra o chip (salvo com uma troca pendente, como antes).
                const par = proximoPar(c);
                if (!par) return;
                if (par.atendente === est.atendente && par.situacao === est.situacao && !est.carregandoAba) { mostrarChip(c); return; }
                sair('chip', c).then((ok) => { if (ok) trocarFiltro(par, false); });   // D17: guarda ANTES de qualquer mutação
            });
            const acao = aviso.querySelector('.tk-fila-aviso-acao');
            acao.addEventListener('click', () => {
                const pa = (aviso.dataset.filtro || '').split(':');
                if (pa.length !== 2 || !chipDa(pa[0]) || !chipDa(pa[1])) return;
                const par = { atendente: pa[0], situacao: pa[1] };
                sair('tentar', acao).then((ok) => { if (ok) trocarFiltro(par, pa[1] !== est.situacao ? pa[1] : pa[0]); });
            });

            // D18: Tab/Shift+Tab rolam o chip para a zona inteira; foco de mouse não (LICOES 43).
            cabeca.addEventListener('focusin', (e) => {
                const c = e.target instanceof Element ? e.target.closest('.tk-chip') : null;
                if (c && c.matches(':focus-visible')) requestAnimationFrame(() => mostrarChip(c));
            });

            // D20: "×" da busca.
            campo = fila.querySelector('.tk-busca input[type="search"]');
            limpar = fila.querySelector('.tk-busca-limpar');
            if (campo && limpar) {
                campo.addEventListener('input', sincLimpar);
                limpar.addEventListener('click', limparBusca);
                campo.addEventListener('keydown', (e) => {
                    if (e.key !== 'Escape' || !haBusca()) return;
                    e.preventDefault();   // sem o limpa-nativo; o LiaFs ignora tecla com defaultPrevented
                    limparBusca();
                });
                sincLimpar();   // o navegador pode ter restaurado o valor
            }
            novosBtn.addEventListener('click', () => {
                lista.scrollTo({ top: 0, behavior: reduzMovimento() ? 'auto' : 'smooth' });
                zerarNovos();
                const primeiro = itens.querySelector('.tk-item .tk-item-abrir');
                if (primeiro) primeiro.focus({ preventScroll: true });
            });
            lista.addEventListener('scroll', () => { if (lista.scrollTop <= 0 && est.novos) zerarNovos(); }, { passive: true });

            // D35 v17 J-5: a URL passa a dizer o par que está na tela (atendente + situacao; aba/lated saem), ANTES do 1º query().
            // R2 do parecer-d14-php continua: se a vista da URL falhou, o servidor abriu Todos · Abertos e é esse par que vai para a URL
            // (um F5 não repete a falha); o "Tentar de novo" (data-filtro) põe o par de volta se der certo.
            trocarUrl(est);
            delete aviso.dataset.falhouNaCarga;

            carimbarEspera();
            setInterval(tique, TIQUE_MS);

            // D24: pulso pendente da aba escondida (A1) e textos/região viva do aviso de transbordo (A3).
            document.addEventListener('visibilitychange', pulsoAoVoltar);
            document.addEventListener('visibilitychange', contagemAoVoltar);
            AvisoTransbordo.init(T, anunciar);

            // D18: ativo inteiro na carga (?aba=X, ?lated=, abaFalhou) e de novo quando a Poppins chega (a largura muda).
            regrupar();        // §5.2: na carga, ANTES do 1º mostrarChip (os títulos são só do JS)
            mostrarAtivos();
            if (document.fonts && document.fonts.ready) document.fonts.ready.then(mostrarAtivos);

            // D27: botão original (o temporário do SaidaDetalhe nunca ganha pílula) e recontagem depois do POST dele.
            proximo = fila.querySelector('.tk-proximo:not(.tk-saida-tmp)');
            proximoDesc = document.getElementById('tk-proximo-desc');
            if (proximo && !comparavel()) limparProximo();   // blade e JS discordando: vale o "sem número"
            const jq = window.jQuery;
            const urlProx = proximo ? proximo.dataset.ajax : '';
            if (urlProx && jq && jq.ajaxPrefilter) {
                jq.ajaxPrefilter((s, orig, jqXHR) => {
                    if (s.url !== urlProx || String(s.type || '').toUpperCase() !== 'POST') return;
                    jqXHR.always(() => { enfileirar([]).catch(() => {}); });
                });
            }
            // D30: 2º prefiltro, só o Assumir da fila (POST em set-responsible com from=tickets). O done roda antes do s.success:
            // marca o id como pendente; o conferirAssumidos solta depois da troca do miolo. Rede: se nenhuma troca chegar ao
            // observer (miolo fora da lista, escrito pela sync), o setTimeout 0 (tarefa seguinte, depois do s.success e do
            // MutationObserver) solta igual.
            if (jq && jq.ajaxPrefilter) {
                jq.ajaxPrefilter((s, orig, jqXHR) => {
                    if (String(s.type || '').toUpperCase() !== 'POST') return;
                    let u;
                    try { u = new URL(String(s.url || ''), location.href); } catch (err) { return; }
                    const casa = URL_ASSUMIR.exec(u.pathname);
                    if (!casa || u.searchParams.get('from') !== 'tickets') return;
                    const id = parseInt(casa[1], 10);
                    jqXHR.done((d) => {
                        if (!d || d.error !== false || !d.result || d.result.chat !== 'falha') return;
                        if (d.result.method !== 'replace-multi-elements') return;   // reload (B-C): a página vai embora
                        avisoChatPendente.add(id);
                        setTimeout(() => soltarAvisoChat(id), 0);
                    });
                });
            }

            // D31 (d31.md §1.4 item 5): Assumir da fila recusado porque o contato está em treinamento da LIA (o botão estava velho
            // na tela). O confirmFunction mostra a recusa; aqui só ressincroniza o item (volta sem o Assumir) e as contagens.
            if (jq && jq.ajaxPrefilter) {
                jq.ajaxPrefilter((s, orig, jqXHR) => {
                    if (String(s.type || '').toUpperCase() !== 'POST') return;
                    let u;
                    try { u = new URL(String(s.url || ''), location.href); } catch (err) { return; }
                    const casa = URL_ASSUMIR.exec(u.pathname);
                    if (!casa || u.searchParams.get('from') !== 'tickets') return;
                    const id = parseInt(casa[1], 10);
                    jqXHR.done((d) => {
                        if (!d || d.error !== true || !d.result || d.result.em_treino !== true || !(id > 0)) return;
                        enfileirar([id]).catch(() => {});
                    });
                });
            }

            contagemJa().catch(() => {});

            // Depois do Lia.init() (app.js, $(document).ready registrado antes): o cleanup dele apagaria nossos handlers.
            setTimeout(() => { assinar(); vigiarConexao(); }, 0);
            // bfcache: o pagehide do Lia.js deixou o canal; re-assina e ressincroniza.
            window.addEventListener('pageshow', (e) => { if (e.persisted) { assinar(); sincronizacaoCompleta(); sincLimpar(); } });

            window.tkFila = {
                receberEvento: receberEvento,
                aoMudar: (fn) => { if (typeof fn === 'function') aoMudarFns.push(fn); },   // D35 bloco H (§5.1)
                estado: () => ({ aba: vista(), atendente: est.atendente, situacao: est.situacao, modo: est.modo, grupos: est.grupos,
                                 carregandoAba: est.carregandoAba, sincronizando: est.sincronizando, aberto: aberto(), novos: est.novos }),
            };
        },
    };
}();

module.exports = FilaAbas;
